var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimeSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55091 13.7695V5.04226H11.2398C11.7938 5.04226 12.2682 5.15589 12.6631 5.38317C13.0609 5.61044 13.3663 5.92152 13.5793 6.31641C13.7924 6.71129 13.8989 7.16158 13.8989 7.66726C13.8989 8.16726 13.7924 8.6147 13.5793 9.00959C13.3663 9.40447 13.0609 9.71697 12.6631 9.94709C12.2682 10.1744 11.7952 10.288 11.2441 10.288H8.92591V9.79368H11.2313C11.6802 9.79368 12.0637 9.70277 12.3819 9.52095C12.7001 9.33629 12.9444 9.08487 13.1148 8.76669C13.2853 8.44567 13.3705 8.07919 13.3705 7.66726C13.3705 7.25249 13.2853 6.88459 13.1148 6.56357C12.9444 6.24254 12.6986 5.99112 12.3776 5.8093C12.0594 5.62749 11.6759 5.53658 11.2271 5.53658H9.08358V13.7695H8.55091Z",
    fill: "#15182C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2721 12.6982L13.2215 13.7488L15.0353 15.5933H10.6294V17.0888H15.0353L13.2215 18.9333L14.2721 19.9839L17.915 16.3411L14.2721 12.6982Z",
    fill: "#15182C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeSend);
export default __webpack_public_path__ + "static/media/Prime_send.19aba07b4bc4105a9cd31588e483814c.svg";
export { ForwardRef as ReactComponent };